/** Stable content adapter; authoring never rewrites this module. */
import { bindContent, contentCatalog } from "../content/catalog"
export let ItemTypesProtection: Partial<Record<string, Partial<Record<string, number>>>> = contentCatalog.items.protection

// Rebuild the complete table group during preparation; activation only assigns bindings.
bindContent(catalog => ({
    ItemTypesProtection: catalog.items.protection,
}), next => {
    ItemTypesProtection = next.ItemTypesProtection
})
